export interface ISaveCancelButtonConfig {
  save: string;
  cancel: string;
  hasCustomCancel: boolean;
  showCancel: boolean;
}

export class SaveCancelButtonConfig implements ISaveCancelButtonConfig {
  save: string = 'Save';
  cancel: string = 'Cancel';
  hasCustomCancel: boolean = false;
  showCancel: boolean = true;

  constructor(configOverride?: Partial<ISaveCancelButtonConfig>) {
    if (configOverride) {
      Object.assign(this, configOverride);
    }
  }
}
